module.exports = {
  messages: [
    { id: 'restriction-text-email', type: 'error' },
    { id: 'restriction-image-content', type: 'error' },
    { id: 'restriction-text-character-number-range', type: 'error' },
    { id: 'restriction-text-swearing', type: 'error' },
    { id: 'restriction-text-date-range', type: 'error' },
    { id: 'restriction-text-number-nan', type: 'error' },
    { id: 'restriction-text-date-format', type: 'error' },
    { id: 'restriction-text-currency-range', type: 'error' },
    { id: 'restriction-text-currency-format', type: 'error' },
    { id: 'restriction-text-number-out-of-range', type: 'error' },
    { id: 'restriction-text-dictionary-not-found', type: 'error' },
    { id: 'upload-error', type: 'error' },
    { id: 'image-processing-error', type: 'info' },
    { id: 'low-resolution', type: 'warning' },
    { id: 'workflow-request-wip', type: 'warning' },
    { id: 'background-color-add', type: 'info' },
    { id: 'global-locked', type: 'error' },
    { id: 'undo-unlocked-layout-image', type: 'info' },
    {
      id: 'locked-layout-image',
      type: 'warning',
      onShow: function () { this.blinkingHint($('a.btn.btn-onmenu[data-action="on_unlockImage"]')); }
    },
    {
      id: 'locked-element',
      type: 'error',
      onShow: function () { this.blinkingHint($('a.btn.btn-onmenu[data-action="on_unlockElement"]')); }
    },
    { id: 'long-time-no-save', type: 'warning' },
    { id: 'uploading-images-save', type: 'warning' },
    { id: 'nothing-to-save', type: 'success' },
    { id: 'already-saved', type: 'success' },
    {
      id: 'saved',
      type: 'success',
      content: function (translate) {
        const now = new Date();
        const H = now.getHours();
        const i = now.getMinutes();
        this.refreshTitle();

        return translate('advice.content.saved', {
          H: H < 10 ? '0' + H : H,
          i: i < 10 ? '0' + i : i
        });
      },
      refreshTitle: function () {
        try {
          const projectName = document.querySelector('div[data-value="project-name"] > span').textContent;
          window.original = `${window.original.split('|')[0]} | ${projectName}`;
          document.title = window.original;
        } catch (e) { }
      }
    },
    { id: 'nothing-to-save', type: 'success' },
    { id: 'img-quality-acceptable', type: 'info' },
    { id: 'low-img-quality-present', type: 'warning' },
    {
      id: 'design-available-for-print-order',
      type: 'info',
      onShow: () => {
        const $getQuote = $('<a>' + INKIVE.TranslateHelper.translate('common.get_quote') + '</a>');

        $('#toast-container').find('.toast-message:first').after($getQuote);
        $getQuote.on('click', () => {
          $('.options > button[data-action="order-print"]').trigger('click');
          $('#toast-container').find('.toast-close-button').trigger('click');
        });
      }
    },
    { id: 'crop-restriction-applied', type: 'success' },
    { id: 'crop', type: 'warning', once: true },
    { id: 'video-download-error', type: 'error' },
    { id: 'pdf-download-error', type: 'error' },
  ]
};
